import type { TranslationContent, Langs } from '@CS/components/TranslationProvider/types';
import Input from '@CS/components/Form/InputField/InputField.module.css';
import type { UseFormRegisterReturn } from 'react-hook-form';
import { useClassNames, useTranslation } from '@CS/hooks';

import { useCallback, useState } from 'react';
import { Content } from '@CS/components/Form';
import CSS from './TextareaField.module.css';
import type { ChangeEvent } from 'react';

type TextareaFieldProps = {
  placeholder?: Record<Langs, string>;
  register: UseFormRegisterReturn;
  onBlur?: () => void;
  maxLength?: number;
  disabled?: boolean;
  error?: boolean;
  width?: number;
  last?: boolean;
  rows?: number;
  name: string;
};

export const TextareaField = ({
  placeholder = { en: '', ar: '' },
  onBlur = () => void 0,
  disabled = false,
  error = false,
  last = false,
  width = 100,
  maxLength,
  register,
  name,
  rows
}: TextareaFieldProps) => {
  const [content, setContent] = useState('');
  const Translations = Content as TranslationContent;

  const fieldLabel = useTranslation(Translations[name]);
  const localizedPlaceholder = useTranslation(placeholder);
  const fieldError = useTranslation(Translations[`${name}Error`]);
  const classNames = useClassNames([CSS.textareaCounter, !error && CSS.valid]);

  const handleChange = (event: ChangeEvent<{ value: string }>) =>
    setFormattedContent(event.target.value);

  const setFormattedContent = useCallback(
    (text: string) => setContent(text.slice(0, maxLength)),
    [maxLength, setContent]
  );

  return (
    <div
      className={Input.fieldContainer}
      style={{
        marginBottom: (last && '0px') || 'revert-layer',
        width: `${width}%`
      }}
    >
      <label htmlFor={name} className={Input.fieldLabel}>
        {fieldLabel}
      </label>

      <textarea
        id={name}
        rows={rows}
        {...register}
        onBlur={onBlur}
        autoComplete="off"
        disabled={disabled}
        maxLength={maxLength}
        onChange={handleChange}
        placeholder={localizedPlaceholder}
        className={`${Input.textareaField} ${CSS.textareaField}`}
      />

      <small className={classNames}>
        {content.length}/{maxLength}
      </small>

      {error && <em className={Input.fieldError}>{fieldError}</em>}
    </div>
  );
};
